import { createContext, useContext, useState, useEffect } from 'react';
import getImageUrl from '../utils/imageUrl';

const ProfileContext = createContext();

export function ProfileProvider({ children }) {
  const [adminProfilePhoto, setAdminProfilePhoto] = useState('https://i.pinimg.com/736x/fb/3f/53/fb3f5378975c7265117a0199ebf40266.jpg');

  const updateAdminProfilePhoto = (newPhoto) => {
    const fixedPhoto = getImageUrl(newPhoto) || newPhoto;
    setAdminProfilePhoto(fixedPhoto);
    localStorage.setItem('adminProfilePhoto', fixedPhoto);
    // Also update in adminSession
    const adminSession = localStorage.getItem('adminSession');
    if (adminSession) {
      try {
        const userData = JSON.parse(adminSession);
        userData.profile_photo = fixedPhoto;
        localStorage.setItem('adminSession', JSON.stringify(userData));
      } catch (error) {
        console.log('Could not update adminSession:', error);
      }
    }
  };

  // Load from localStorage and backend on mount
  useEffect(() => {
    // Try localStorage first and fix URLs
    const savedAdmin = localStorage.getItem('adminProfilePhoto');
    
    if (savedAdmin) {
      const fixedAdmin = getImageUrl(savedAdmin) || savedAdmin;
      setAdminProfilePhoto(fixedAdmin);
      if (fixedAdmin !== savedAdmin) {
        localStorage.setItem('adminProfilePhoto', fixedAdmin);
      }
    }
    
    // Then sync from backend
    syncFromBackend();
  }, []);
  
  const syncFromBackend = async () => {
    try {
      // Sync admin photo from backend
      const adminSession = localStorage.getItem('adminSession');
      if (adminSession) {
        const userData = JSON.parse(adminSession);
        if (userData.profile_photo) {
          const fixedPhoto = getImageUrl(userData.profile_photo) || userData.profile_photo;
          setAdminProfilePhoto(fixedPhoto);
          localStorage.setItem('adminProfilePhoto', fixedPhoto);
          // Update session if URL was fixed
          if (fixedPhoto !== userData.profile_photo) {
            userData.profile_photo = fixedPhoto;
            localStorage.setItem('adminSession', JSON.stringify(userData));
          }
        }
      }
    } catch (error) {
      console.log('Could not sync profile photos from backend:', error);
    }
  };

  return (
    <ProfileContext.Provider value={{ 
      adminProfilePhoto, 
      updateAdminProfilePhoto
    }}>
      {children}
    </ProfileContext.Provider>
  );
}

export function useProfile() {
  const context = useContext(ProfileContext);
  if (!context) {
    throw new Error('useProfile must be used within ProfileProvider');
  }
  return context;
}

// Hook for getting current user's profile photo
export function useCurrentProfilePhoto() {
  const { adminProfilePhoto } = useProfile();
  return adminProfilePhoto;
}

// Hook for getting current user's update function
export function useCurrentProfileUpdate() {
  const { updateAdminProfilePhoto } = useProfile();
  return updateAdminProfilePhoto;
}